// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"375":"kunden","378":"user","435":"kundenformular","733":"projekte","853":"kundendetail"}[chunkId] + "." + {"375":"9a92f390","378":"89e88996","435":"9a3763ec","733":"5a4abc29","853":"c60eca67"}[chunkId] + ".css";
};